// imports shared across all about templates
// imported from about entry points

// global imports
require('../../assets/shared');
require('../../assets/shared_functions');
require('../../site_scripts/mtc_vue_import');
require('../../site_scripts/mtc_lazy_load_images');
require('../../site_scripts/mtc_mobile_menu');
require('../../global/tabs')

// about imports
